export default "__VITE_ASSET__e52231ff__"